<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <div class="pagination-container">
          <el-pagination
            :disabled="isLoading"
            :current-page="listQuery.page"
            :page-sizes="listQuery.sizes"
            :page-size="listQuery.size"
            :total="listQuery.total"
            background
            layout="total, sizes, pager, jumper"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"/>
        </div>
        <div class="button-container">
          <el-button
            class="add-button"
            type="primary"
            icon="el-icon-upload2"
            @click="showUploadModal = true">Upload CSV</el-button>
        </div>
      </div>
    </template>

    <el-table
      v-loading="isLoading"
      :data="list"
      border
      stripe
      style="width: 100%">
      <el-table-column
        prop="id"
        label="Id"
        width="50"/>
      <el-table-column
        prop="admin_id"
        label="Admin Id"
        width="80"/>
      <el-table-column
        prop="admin_name"
        label="Admin Name"
        min-width="200"/>
      <el-table-column
        label="Updated Orders Count"
        align="center"
        width="155">
        <template slot-scope="scope">
          <div class="status-row">
            <el-tag type="success">{{ scope.row.details.length }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Uploaded At"
        width="150">
        <template slot-scope="scope">
          <i class="el-icon-time"/>
          <span style="margin-left:5px;">{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="Action"
        align="center"
        width="110">
        <template slot-scope="scope">
          <el-button
            type="info"
            size="mini"
            icon="el-icon-document"
            @click="showOrderHistory(scope.row)">History</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :before-close="shouldCloseUploadModal"
      :visible.sync="showUploadModal"
      title="Upload Order Payment Status CSV">
      <div
        v-loading="isUploading"
        class="uploader-wrapper">
        <el-upload
          ref="uploader"
          :limit="1"
          :disabled="isUploading"
          :http-request="handleUpload"
          :before-upload="hanldeBeforeUpload"
          :on-exceed="handleUploaderlimitExceed"
          :on-error="uploadfailed"
          :on-success="uploadSuccessful"
          class="uploader"
          drag
          accept="text/csv"
          action="noneed">
          <i class="el-icon-upload"/>
          <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
          <div
            slot="tip"
            class="el-upload__tip">Only <strong>CSV</strong> file is accepted</div>
        </el-upload>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="showListDetailModal"
      title="Updated Order History">
      <el-table :data="selectedListDetail">
        <el-table-column
          prop="order_id"
          label="Order Id"
          width="80"/>
        <el-table-column
          prop="from_payment_status"
          label="From Status"
          min-width="200"/>
        <el-table-column
          prop="to_payment_status"
          label="To Status"
          min-width="200"/>
      </el-table>
    </el-dialog>
  </sticky-header-layout>
</template>

<script>
import useTablePaging from '../../../mixins/useTablePaging'
import { getPaymentStatusUploadHistoryList, uploadPaymentStatus } from '../../../api/rewardsnap'

export default {
  name: 'OrderPaymentStatusUploadHistory',
  mixins: [useTablePaging],
  data() {
    return {
      isUploading: false,
      showUploadModal: false,
      showListDetailModal: false,
      selectedListDetail: null,
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      this.isLoading = true
      try {
        const response = await getPaymentStatusUploadHistoryList(1, this.listQuery.page, this.listQuery.limit)
        const { data: newList, pagination } = response

        this.list = newList

        this.listQuery.total = parseInt(pagination.total_items, 0)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    showOrderHistory(record) {
      this.selectedListDetail = record.details
      this.$nextTick(() => {
        this.showListDetailModal = true
      })
    },
    shouldCloseUploadModal(done) {
      if (!this.isUploading) {
        return done()
      }
      return undefined
    },
    async handleUpload(uploadAction) {
      const { file } = uploadAction
      try {
        await uploadPaymentStatus(file, 1)
        uploadAction.onSuccess()
      } catch (error) {
        uploadAction.onError(error)
      }
    },
    uploadSuccessful() {
      this.getList()
      setTimeout(() => {
        this.clearUploaderFiles()
        this.isUploading = false
        this.$alert(
          'Upload Successful',
          'Yeah!', {
            type: 'success',
            confirmButtonText: 'Cool!',
          },
        )
      }, 500)
    },
    uploadfailed() {
      this.isUploading = false
      this.$alert(
        'Please try again later.',
        'Upload Failed', {
          type: 'error',
          confirmButtonText: 'OK',
        },
      )
    },
    hanldeBeforeUpload(file) {
      if (file.type !== 'text/csv') {
        this.$alert(
          'Please make sure it is an CSV file!',
          'Incorrect File Type', {
            type: 'error',
            confirmButtonText: 'OK',
          },
        )
        return false
      }

      // Let user a chance to make sure he or she is uploading the correct report.
      return this.$confirm(
        'Do you want to upload the CSV now?',
        'Confirm Upload', {
          confirmButtonText: 'Upload',
          cancelButtonText: 'Cancel',
          type: 'warning',
        },
      ).then(() => {
        this.isUploading = true
        return true
      }).catch(() => Promise.reject())
    },
    handleUploaderlimitExceed() {
      this.$alert(
        'Sorry, please upload one file at a time!',
        'Too Many Files', {
          type: 'error',
          confirmButtonText: 'OK',
        },
      )
    },
    clearUploaderFiles() {
      this.$refs.uploader.clearFiles()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";

.uploader-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  .uploader {
    width: 360px;
  }
}

</style>

